import React from "react";
import {Nullable} from "@data-force/app";
import {
    ClockCircleOutlined,
    HourglassOutlined,
    CheckCircleOutlined,
    ReloadOutlined,
    CopyOutlined,
    DollarOutlined,
    CheckOutlined,
    CloseOutlined,
} from "@ant-design/icons";
import {Tooltip} from "antd";
import {TranslateFunction} from "react-localize-redux";
import {useSelector} from "react-redux";
import {selectTranslate} from "../../store/selectors/translate";
import "./CardInfo.scss";
import {ReadyTasksIcon} from "../../assets/Icons";

interface Props {
    data: Nullable<string | number>
    type: string
}
interface IconsMap {
    [key: string]: React.ReactNode
}

const CardInfo: React.FC<Props> = ({data, type}: Props): React.ReactElement => {
    const translatePath: string = "components.CardInfo.CardInfo";
    const translate: TranslateFunction = useSelector(selectTranslate);
    const locale: string = translate(`${translatePath}.${type}.text`) as string;

    const iconsMap: IconsMap = {
        timeEstimate: <ClockCircleOutlined aria-label={locale}/>,
        timeLimit: <HourglassOutlined aria-label={locale}/>,
        passingScore: <CheckCircleOutlined aria-label={locale}/>,
        attempts: <ReloadOutlined aria-label={locale}/>,
        availableToClaim: <CopyOutlined aria-label={locale}/>,
        approvedForPaymentTasks: <DollarOutlined aria-label={locale}/>,
        completedTasks: <CheckOutlined aria-label={locale}/>,
        rejectedTasks: <CloseOutlined aria-label={locale}/>,
        readyTasks: (<span role="img"><ReadyTasksIcon aria-label={locale}/></span>),
    };

    /**
     * Helper function for generating QA class depending on the type
     * @returns {string}
     */
    const generateQaClass = (): string => {
        const formatType: string = type.replace(/[A-Z]/g, (match: string): string => `-${match.toLowerCase()}`);
        return `df-qa-${formatType}-stat`;
    };

    return (
        <div className={`df-card-info ${generateQaClass()}`}>
            <Tooltip title={locale}>
                {iconsMap[type] as keyof IconsMap}
                <span>{data}</span>
            </Tooltip>
        </div>
    );
};

export default CardInfo;
